<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.05757 6.66616L3.06113 11.011C2.67098 11.5767 2.67098 12.3247 3.06113 12.8904L6.05757 17.2352C6.36652 17.6832 6.87594 17.9507 7.42013 17.9507L16.8958 17.9507C17.81 17.9507 18.551 17.2096 18.551 16.2955L18.551 7.60586C18.551 6.69173 17.81 5.95068 16.8958 5.95068L7.42013 5.95068C6.87594 5.95068 6.36652 6.21818 6.05757 6.66616Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.09814 8.76721C9.51236 8.76721 9.84814 9.103 9.84814 9.51721C9.84814 9.93143 9.51236 10.2672 9.09814 10.2672C8.68393 10.2672 8.34814 9.93143 8.34814 9.51721C8.34814 9.103 8.68393 8.76721 9.09814 8.76721Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.5"
    />
    <path
      d="M14.0557 13.8831C14.4699 13.8831 14.8057 14.2188 14.8057 14.6331C14.8057 15.0473 14.4699 15.3831 14.0557 15.3831C13.6415 15.3831 13.3057 15.0473 13.3057 14.6331C13.3057 14.2188 13.6415 13.8831 14.0557 13.8831Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="0.5"
    />
    <path
      d="M9.09814 14.6331L14.0558 9.51719"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CouponIcon',
  props: {
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 24
    }
  }
}
</script>

<style scoped></style>
